/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable import/prefer-default-export */

import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { ThemeProvider } from 'styled-components';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import { msalConfig } from './config/authConfig';
import { AuthProvider } from './common/auth';
import theme from './config/theme';
import { clarity } from 'react-microsoft-clarity';
import { APP_ENV, CLARITY_ID } from './config';


const container = document.getElementById('root');
const root = createRoot(container!);
export const msalInstance = new PublicClientApplication(msalConfig);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function addClarity()
{
  // undefined means to not run in dev environment
  if (APP_ENV === 'prod' && CLARITY_ID != 'undefined') {
    clarity.init(CLARITY_ID);
  }
}

root.render(
  <ThemeProvider theme={theme}>
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </MsalProvider>
  </ThemeProvider>,
);

addClarity();